// import React from 'react';
// import dynamic from 'next/dynamic';
// import type { Variants } from 'motion/react';

// import { Entity, Snippet, SNIPPET_TYPE } from '@repo/types';

// import { TabContentItem } from './tab-content-item';

// const MotionDiv = dynamic(
//   () => import('motion/react').then((mod) => mod.motion.div),
//   {
//     ssr: false,
//   },
// );

// const tabContentVariants: Variants = {
//   active: {
//     display: 'block',
//     transition: {
//       staggerChildren: 0.2,
//     },
//   },
//   inactive: {
//     display: 'none',
//     transition: {
//       duration: 0,
//     },
//   },
// };

// interface AccordionState {
//   isCollapsed: boolean;
//   expandedAccordions: Set<number>;
// }

// export interface TabContentProps {
//   id: string;
//   active: boolean;
//   data: Snippet[];
//   entities?: Entity[];
//   accordionsState: AccordionState;
//   updateAccordionState: (
//     tabType: SNIPPET_TYPE,
//     index: number,
//     isExpanded: boolean,
//   ) => void;
//   tabType: SNIPPET_TYPE;
// }

// export const TabContent: React.FC<TabContentProps> = ({
//   id,
//   active,
//   data,
//   entities,
//   accordionsState,
//   updateAccordionState,
//   tabType,
// }) => {
//   return (
//     <MotionDiv
//       id={id}
//       variants={tabContentVariants}
//       animate={active ? 'active' : 'inactive'}
//       initial="inactive"
//       role="tabpanel"
//       className="pb-0 pt-2 @cred-xl:pb-0 @cred-xl:pt-4"
//     >
//       {data && data.length > 0 ? (
//         data.map((snippet, index) => (
//           <TabContentItem
//             key={index}
//             entities={entities}
//             snippet={snippet}
//             index={index}
//             accordionsState={accordionsState}
//             updateAccordionState={updateAccordionState}
//             tabType={tabType}
//           />
//         ))
//       ) : (
//         <div className="flex h-11 w-full items-center justify-center">
//           <p className="font-medium text-neutral-1">No snippets found</p>
//         </div>
//       )}
//     </MotionDiv>
//   );
// };

import React from 'react';
import dynamic from 'next/dynamic';
import type { Variants } from 'motion/react';

import { Snippet, SNIPPET_TYPE } from '@repo/types';

import { TabContentItem } from './tab-content-item';

const MotionDiv = dynamic(
  () => import('motion/react').then((mod) => mod.motion.div),
  {
    ssr: false,
  },
);

const tabContentVariants: Variants = {
  active: {
    display: 'block',
    transition: {
      staggerChildren: 0.2,
    },
  },
  inactive: {
    display: 'none',
    transition: {
      duration: 0,
    },
  },
};

interface AccordionState {
  isCollapsed: boolean;
  expandedAccordions: Set<number>;
}

interface TabContentProps {
  id: string;
  active: boolean;
  data: Snippet[];
  accordionsState: AccordionState;
  updateAccordionState: (
    tabType: SNIPPET_TYPE,
    index: number,
    isExpanded: boolean,
  ) => void;
  tabType: SNIPPET_TYPE;
}

export const TabContent: React.FC<TabContentProps> = ({
  id,
  active,
  data,
  accordionsState,
  updateAccordionState,
  tabType,
}) => {
  return (
    <MotionDiv
      id={id}
      variants={tabContentVariants}
      animate={active ? 'active' : 'inactive'}
      initial="inactive"
      role="tabpanel"
      className="space-y-2 px-3 pb-0 pt-2 @cred-md:px-[14px] @cred-xl:px-5 @cred-xl:pb-0 @cred-xl:pt-4"
    >
      {data && data.length > 0 ? (
        data.map((snippet, index) => (
          <TabContentItem
            key={index}
            snippet={snippet}
            index={index}
            accordionsState={accordionsState}
            updateAccordionState={updateAccordionState}
            tabType={tabType}
          />
        ))
      ) : (
        <div className="flex h-11 w-full items-center justify-center">
          <p className="font-medium text-neutral-1">No snippets found</p>
        </div>
      )}
    </MotionDiv>
  );
};
